(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-metafields"]) return;
  try {
    
  $(document).ready(function() {
    $('ul.product-tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
	  $('iframe[src*="youtube"]').wrap("<div class='embed-container'></div>");
	  $('iframe[src*="vimeo"]').wrap("<div class='embed-container'></div>");

    });
  });

  } catch(e) { console.error(e); }
})();

})();
